import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ theme = "dark", ...props }) => (
  <Sonner theme={theme} className="toaster group" {...props} />
)

export { Toaster, toast }
